import React, { useState, useEffect } from "react";
import TooltipOffers from "../TooltipOffers/TooltipOffers";
import { css } from "emotion";

import { formatCurrency, floatFormat } from "../utils/formats";
import { useNewOffer } from "../../../js/context/new-offer";

import { boxTotalExpectedGainStyle } from "./style";

const BoxTotalExpectedGain = ({}) => {
	const [total, setTotal] = useState(0);
	const [ruleShow, setRuleShow] = useState(false);

	const { offerData, pricesData } = useNewOffer();

	useEffect(
		() => {
			const { price, quant } = offerData.data;
			const { minMiles, maxMiles, minPrice, maxPrice } = pricesData.data;

			setTotal(parseInt(quant) / 1000 * floatFormat(price.toString()));
			setRuleShow(
				floatFormat(price.toString()) >= minPrice &&
					floatFormat(price.toString()) <= maxPrice &&
					parseInt(quant) >= minMiles &&
					parseInt(quant) <= maxMiles
			);
		},
		[offerData, pricesData]
	);

	return (
		ruleShow && (
			<div
				className={css`
					${boxTotalExpectedGainStyle};
				`}
			>
				<p className="text">Você pode receber até</p>
				<div className="price-area">
					<p className="price-area--text">R${formatCurrency(total)}</p>
					<TooltipOffers
						position="top-start"
						content={
							<p style={{ fontWeight: "bold", textAlign: "left" }}>
								Valor total a receber caso venda todas as milhas.
							</p>
						}
					/>
				</div>
			</div>
		)
	);
};

export default BoxTotalExpectedGain;
